export default "__VITE_ASSET__CMH5ci29__"